export default __webpack_public_path__ + "static/06-a241a05285e420aa45076fbb5e06bd74.png";